export const AuthErrors = {
    'user not found': 'Пользователь не найден',
    'user already exists': 'Пользователь уже зарегистрирован'
}